import React from 'react';
import {ClickAwayListener, Tooltip} from "@mui/material";
import cl from "./InlineTip.module.css";
import InlineTipIcon from "./Icons/InlineTipIcon";

const InlineTip = ({text, style}) => {

    const [open, setOpen] = React.useState(false);

    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Tooltip
                describeChild
                onClose={() => setOpen(false)}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                slotProps={{popper: {disablePortal: true}}}
                title={<div className={cl.tip}>{text}</div>}
                placement={"right-end"}
                arrow
            >
                <button className={cl.btn} onClick={() => setOpen(!open)} style={style}>
                    <span className={cl.btnOverlay}>
                        <InlineTipIcon fgColor="#446688" bgColor="#446688" bgOpacity={0.15}/>
                    </span>
                </button>
            </Tooltip>
        </ClickAwayListener>
    );
};

export default InlineTip;